/** @jsxRuntime automatic */
import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "./utils";
import { controlBase, controlSizes, type ControlSize } from "./control";

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "size"> {
  /**
   * Height, the same scale as Button (components-15): `default` 44 px
   * everywhere; `md` 36 px and `sm` 32 px with a mouse in the wide layout,
   * 44 px with a finger. Pick the size of the button that sits beside it.
   */
  size?: ControlSize;
}

/** Single-line field, 44 px with a finger (same height as the Button beside it). */
export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, size = "default", ...props }, ref) => (
    <input
      type={type}
      className={cn("flex", controlBase, controlSizes[size], className)}
      ref={ref}
      {...props}
    />
  ),
);
Input.displayName = "Input";
